import React from "react";

const items = [
  "⚡ LAKOSSÁGI",
  "ZÁRLAT? HÍVJ MOST",
  "IPARI KIVITELEZÉS",
  "OKOSOTTHON",
  "FI RELÉ CSERE",
  "BIZTOSÍTÉKTÁBLA",
  "0-24 ÜGYELET",
  "VILLÁMVÉDELEM",
  "MÉRŐHELY KIALAKÍTÁS",
];

export default function Marquee() {
  const doubled = [...items, ...items];
  return (
    <div data-testid="marquee" className="marquee text-[#FFD700]">
      <div className="marquee-track">
        {doubled.map((t, i) => (
          <span key={i} className="flex items-center gap-3">
            <span>{t}</span>
            <span className="text-[#262626]">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
